<template>
  <div id="page-top-balance">
    <vx-card title="20 อันดับเครดิตสูงสุดในกระเป๋า">
      <div class="flex flex-wrap items-center mb-4">
        <vs-button color="primary" icon-pack="feather" icon="icon-refresh-cw" @click="fetchData">
          ดึงข้อมูล
        </vs-button>
        <span v-if="lastUpdated" class="ml-4 text-sm opacity-75">
          อัปเดตล่าสุด: {{ lastUpdated }}
        </span>
      </div>

      <vs-table search stripe :data="members" noDataText="ยังไม่มีข้อมูล กดปุ่ม 'ดึงข้อมูล'">
        <template slot="thead">
          <vs-th>อันดับ</vs-th>
          <vs-th sort-key="username">Username</vs-th>
          <vs-th sort-key="name">ชื่อ - นามสกุล</vs-th>
          <vs-th sort-key="phone">เบอร์โทรศัพท์</vs-th>
          <vs-th sort-key="balance">เครดิตคงเหลือ</vs-th>
          <vs-th></vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="(tr, i) in data" :key="i" :data="tr">
            <vs-td>
              <span v-if="medal(tr.rank)" class="text-xl mr-1">{{ medal(tr.rank) }}</span>
              <span class="font-semibold">{{ tr.rank }}</span>
            </vs-td>
            <vs-td>{{ tr.username }}</vs-td>
            <vs-td>{{ tr.name || '-' }}</vs-td>
            <vs-td>{{ tr.phone || '-' }}</vs-td>
            <vs-td>
              <span class="font-semibold text-success">{{ currency(tr.balance) }}</span>
            </vs-td>
            <vs-td>
              <router-link v-if="tr.username" :to="`/member/${tr.username}`">
                <vs-button size="small" color="success" type="border" icon-pack="feather" icon="icon-file-text">
                  ข้อมูลยูสเซอร์
                </vs-button>
              </router-link>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import axios from '../../axios'
import moment from 'moment'

export default {
  data () {
    return {
      members: [],
      lastUpdated: ''
    }
  },
  methods: {
    medal (rank) {
      return { 1: '🥇', 2: '🥈', 3: '🥉' }[rank] || ''
    },
    currency (amount) {
      if (amount === null || amount === undefined || amount === '' || amount === 'NaN') {
        amount = 0
      }
      const num = Number(amount)
      const n = Number.isFinite(num) ? num : 0
      const negative = n < 0
      const parts = String(Math.abs(n)).split('.')
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      const formatted = parts.length > 1 ? `${parts[0]}.${parts[1]}` : parts[0]
      return negative ? `-${formatted}` : formatted
    },
    normalize (list) {
      return list.map((item, index) => ({
        rank: index + 1,
        username: item.member_username || item.username || item.user || '',
        name: [item.member_name || item.name, item.member_surname || item.surname]
          .filter(Boolean).join(' '),
        phone: item.member_phone || item.phone || '',
        balance: item.balance != null ? item.balance
          : (item.credit != null ? item.credit
            : (item.member_balance != null ? item.member_balance : 0))
      }))
    },
    fetchData () {
      this.$vs.loading()
      axios
        .get('/member/top-balance')
        .then(response => {
          const raw = Array.isArray(response.data)
            ? response.data
            : (response.data.data || response.data.members || [])
          this.members = this.normalize(raw)
          this.lastUpdated = moment.tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
        })
        .catch(error => {
          console.error(error)
          this.$vs.notify({
            color: 'danger',
            title: 'ดึงข้อมูลไม่สำเร็จ',
            text: 'ไม่สามารถโหลดข้อมูล 20 อันดับเครดิตสูงสุดได้'
          })
        })
        .finally(() => {
          this.$vs.loading.close()
        })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
